// removed by extract-text-webpack-plugin
module.exports = {"centered":"centered__sPb-2","imagePreview":"imagePreview__410MV","image":"image__3n40p"};


//////////////////
// WEBPACK FOOTER
// ./components/image/styles.styl
// module id = Eh0G
// module chunks = 0